const img = { key: "image_url", label: "Görsel adresi (URL)", type: "image", default: "" };
const active = { key: "active", label: "Sitede göster", type: "switch", default: true };
const order = { key: "order", label: "Sıra", type: "number", default: 0 };

export const CRUD_CONFIGS = {
  kurslar: {
    api: "courses", title: "Kurslar", singular: "Kurs",
    fields: [
      { key: "name", label: "Kurs adı", type: "text", required: true, default: "" },
      { key: "category_id", label: "Kategori", type: "category", required: true, default: "" },
      { key: "age_group", label: "Yaş grubu", type: "text", default: "", placeholder: "ör. 6 yaş ve üzeri" },
      { key: "level", label: "Seviye", type: "text", default: "", placeholder: "ör. Başlangıç – Orta" },
      { key: "duration", label: "Süre", type: "text", default: "", placeholder: "ör. 45 dk · haftada 1 ders" },
      { key: "description", label: "Açıklama", type: "textarea", default: "" },
      img,
      { key: "price", label: "Fiyat (₺, isteğe bağlı)", type: "number", default: "", nullable: true },
      { key: "show_price", label: "Fiyatı sitede göster", type: "switch", default: false },
      { key: "featured", label: "Ana sayfada öne çıkar", type: "switch", default: false },
      active, order,
    ],
    display: (it, cats) => ({
      title: it.name, subtitle: cats[it.category_id] || "—", image: it.image_url,
      badges: [it.featured && "Öne çıkan", it.show_price && it.price != null && `${it.price} ₺ görünür`, !it.active && "Gizli"].filter(Boolean),
    }),
  },
  kategoriler: {
    api: "categories", title: "Kategoriler", singular: "Kategori",
    fields: [
      { key: "name", label: "Kategori adı", type: "text", required: true, default: "", placeholder: "ör. Resim, Drama, Okuma" },
      { key: "description", label: "Kısa açıklama", type: "text", default: "" },
      active, order,
    ],
    display: (it) => ({ title: it.name, subtitle: it.description, badges: [!it.active && "Gizli"].filter(Boolean) }),
  },
  ogretmenler: {
    api: "teachers", title: "Öğretmenler", singular: "Öğretmen",
    fields: [
      { key: "name", label: "Ad Soyad", type: "text", required: true, default: "" },
      { key: "branch", label: "Branş", type: "text", default: "" },
      { key: "bio", label: "Tanıtım", type: "textarea", default: "" },
      img, active, order,
    ],
    display: (it) => ({ title: it.name, subtitle: it.branch, image: it.image_url, badges: [!it.active && "Gizli"].filter(Boolean) }),
  },
  galeri: {
    api: "gallery", title: "Galeri", singular: "Görsel",
    fields: [{ ...img, required: true }, { key: "caption", label: "Açıklama", type: "text", default: "" }, active, order],
    display: (it) => ({ title: it.caption || "Görsel", image: it.image_url, badges: [!it.active && "Gizli"].filter(Boolean) }),
  },
  etkinlikler: {
    api: "events", title: "Etkinlikler", singular: "Etkinlik",
    fields: [
      { key: "title", label: "Başlık", type: "text", required: true, default: "" },
      { key: "date", label: "Tarih", type: "date", required: true, default: "" },
      { key: "time", label: "Saat", type: "time", default: "" },
      { key: "location", label: "Konum", type: "text", default: "" },
      { key: "description", label: "Açıklama", type: "textarea", default: "" },
      img, active,
    ],
    display: (it) => ({ title: it.title, subtitle: `${it.date} ${it.time || ""} · ${it.location || ""}`, image: it.image_url, badges: [!it.active && "Gizli"].filter(Boolean) }),
  },
};
